export async function fetchData() {
  try {
    const jobListingsResponse = await fetch(
      'https://api.greenhouse.io/v1/boards/scaleai/jobs?content=true'
    );
    const jobListingsData = await jobListingsResponse.json();

    const officesResponse = await fetch('https://api.greenhouse.io/v1/boards/scaleai/offices');
    const officesData = await officesResponse.json();

    const departmentsResponse = await fetch(
      'https://api.greenhouse.io/v1/boards/scaleai/departments'
    );
    const departmentsData = await departmentsResponse.json();

    return {
      jobListings: jobListingsData.jobs,
      offices: officesData.offices,
      departments: departmentsData.departments
    };
  } catch (error) {
    throw new Error('Failed to fetch job data');
  }
}
